export default __webpack_public_path__ + "static/media/hamburger-menu-img2.7b15de3c.jpg";